/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@mui/material'
import { FC, useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Grid } from 'src/components/UI'
import Icon from 'src/components/UI/CustomUI/atoms/Icon'
// import { SelectInputOption } from 'src/components/UI/CustomUI/atoms/SelectInput/types'
import ExportCSV from 'src/components/UI/CustomUI/molecules/ExportCSV'
import Table from 'src/components/UI/CustomUI/organisms/Table'
// import TablePagination from 'src/components/UI/CustomUI/organisms/Table/TablePagination'
import {
  contractorsActions,
  territoriesActions,
  // filtersActions
} from 'src/ducks/actions'
import {
  getAllContractors,
  // getTotalContractorsCount
} from 'src/ducks/contractors/selectors'
// import { getContractorsFilter } from 'src/ducks/filters/selector'
// import { ContractorsFilterType } from 'src/ducks/filters/types'
import { ContractorItem } from 'src/ducks/types'
import { formatTimestamp, getOptionsFromArrayMultiple, headerCSVParser, ROWS_PER_PAGE_EXTENDED } from 'src/helpers'
import { ContractorsContext } from './context'
import { dispatchTypes, MODAL_TYPE } from './context/types'
import ContractorsModal from './modals'
import styles from './styles.module.scss'
// import Toolbar from './Toolbar'

import headers from './headers'
import Toolbar from './Toolbar'
import { getTerritories } from 'src/ducks/selectors'

const Contractors: FC = () => {
  const dispatch = useDispatch()
  const { dispatch: dispatchContext } = useContext(ContractorsContext)

  const allContractors = useSelector(getAllContractors)
  const territories = useSelector(getTerritories)
  // const totalCount = useSelector(getTotalContractorsCount)
  // const contractorsFilter = useSelector(getContractorsFilter())

  const [allContractorsLoading, setAllContractorsLoading] = useState<boolean>(false)
  // const [selectedTableContractors, setSelectedTableContractors] = useState<any>([])
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(50)

  // const search = contractorsFilter.search || ''
  // const institutional = contractorsFilter.institutional || null

  // const affiliatesStages = useMemo(
  //   () => {
  //     return getOptionsFromArrayMultiple(allContractors, { key: 'id', label: 'name' })
  //   },
  //   [allContractors]
  // )
  // const selectedAffiliates = useMemo(
  //   () => {
  //     return contractorsFilter.selectedAffiliates || []
  //   },
  //   [contractorsFilter]
  // )
  // const selectedCount = useMemo(
  //   () => selectedAffiliates.filter((aff) => !aff.hide).length,
  //   [selectedAffiliates]
  // )

  // CSV
  const headersWithoutSettings = headers.filter((header) => header.id !== 'settings')
  const headersCSV: any = headerCSVParser(headers)
  const dataCSV = allContractors?.length > 0 ? allContractors?.reduce((acc: any, curr: any) => {
    const contractor = {
      ...curr,
      contractorName: curr?.name || '',
      link: curr?.websiteUrl || '',
      email: curr?.email || '',
      firstName: curr?.firstName || '',
      lastName: curr?.lastName || '',
      docuSignLink: curr?.docuSignLink || '',
    }
    acc = [...acc, contractor]
    return acc
  }, []) : []


  const fetchAllContractors = () => {

    setAllContractorsLoading(true)
    dispatch(
      contractorsActions.fetchAllContractors(
        { searchParams: {} },
        (succ) => {
          setAllContractorsLoading(false)
        }
      )
    )
  }

  const fetchTerritories = () => {
    dispatch(territoriesActions.fetchTerritories(
      { searchParams: {} },
      (succ) => {
      }
    ))
  }

  // const updateContractorsFilter = (newFilter: Partial<ContractorsFilterType>) => {
  //   dispatch(
  //     filtersActions.setFilters({
  //       contractors: {
  //         ...contractorsFilter,
  //         ...newFilter,
  //       },
  //     })
  //   )
  // }

  const attachSettingHandler = (arr: ContractorItem[]) => {
    if (arr && arr.length > 0) {
      return arr.map((contractor) => ({
        ...contractor,
        handleSettings,
        territory: territories.filter((territory) => territory.contractors.some((c) => c.id === contractor.id)).map((t) => t.title).join(', ') || '-'
        // FUTURE: múltiples territorios → .filter(...).map(t => t.title).join(', ') || '-'
      }))
    }
    return []
  }

  // // set table list with selected contractors
  // const setSelectedContractorsForTable = () => {
  //   const length = selectedCount || allContractors.length
  //   const start = page * size
  //   const end = start + size > length ? length : start + size

  //   setSelectedTableContractors(
  //     allContractors
  //       .filter((contractor, index) => {
  //         const targetAff = selectedAffiliates.find(
  //           (aff) => aff.id === contractor.id
  //         )
  //         return !targetAff?.hide || !selectedCount
  //       })
  //       .slice(start, end)
  //   )
  // }

  // const setSelectedAffiliates = (newAffiliates: SelectInputOption[]) => {
  //   updateContractorsFilter({
  //     selectedAffiliates: newAffiliates,
  //   })
  // }

  useEffect(() => {
    fetchAllContractors()
    fetchTerritories()
  }, [])

  // useEffect(() => {
  //   setSelectedContractorsForTable()
  // }, [selectedCount, page, size, allContractors])

  // useEffect(() => {
  //   setSelectedAffiliates(affiliatesStages)
  // }, [affiliatesStages])

  const handleSettings = (row: any) => {
    dispatch(contractorsActions.setContractor(row))
    dispatchContext({
      type: dispatchTypes.SET_VALUE,
      payload: {
        attr: 'modalType',
        value: MODAL_TYPE.EDIT,
      },
    })
    dispatchContext({
      type: dispatchTypes.SET_VALUE,
      payload: {
        attr: 'modalOpen',
        value: true,
      },
    })
  }
  return (
    <Box>
      <ContractorsModal />
      <Box display="flex" flexDirection="column" gap={1}>
        <Box display="flex" flexDirection="row" gap={1}>
          <Toolbar
          />
          <Box display="flex" alignSelf="flex-end">
            <ExportCSV
              headers={headersCSV}
              data={dataCSV}
              fileName='contractors.csv'
              label={<Button sx={{ padding: '8px !important' }} variant='containedLight'><Icon name='CloudDownload' /></Button>}
            />
          </Box>
        </Box>
        <Box className={styles.Contractors__tableContainer}>
          <Table
            headers={headers}
            sortable
            defaultOrder="desc"
            loading={allContractorsLoading}
            hasPagination={false}
          >
            {attachSettingHandler(allContractors)}
          </Table>
        </Box>
      </Box>
    </Box>
  )
}

export default Contractors
